export const BENCHMARK_DIGEST_TITLE = "activation.settings.section.email.subtitle";
export const BENCHMARK_DIGEST_TITLE_TOOLTIP = "activation.settings.section.email.subtitle.tooltip.text";
export const RECEIVE_TEXT = "activation.settings.section.email.toggle.text";

export const RECEIVE_ALERT_TEXT = "activation.settings.section.email.receive.text";
export const COMPETITORS_ALERTS_TITLE = "activation.settings.section.email.competitors_alerts.title.text";
export const COMPETITORS_ALERTS_TOOLTIP = "activation.settings.section.email.competitors_alerts.title.tooltip.text";
export const FREQUENCY_TEXT = "bt.report.frequency.text";
export const EMAIL_TEXT = "activation.settings.section.email.address.title";

export const NEWS_LEVER_RECEIVE_LABEL = "activation.settings.news.leveler.title";
export const NEWS_LEVER_ERROR = "activation.settings.news.leveler.error.toast";
export const NEWS_LEVER_RECEIVE_TOOLTIP = "activation.settings.news.leveler.tooltip";
